/*
    This script defines an unauthenticated POST and GET function for each 
    component
*/
import fetch from "isomorphic-unfetch"
import urlBeginning from "./urlConstructor"

export const makeUnauthPostRequest = ({ url, body, onSuccess, onFailure }) =>
  fetch(urlBeginning + url, {
    body: JSON.stringify(body),
    method: "POST",
    redirect: "follow",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then(async (el) => {
      const { status } = el

      let data
      try {
        data = await el.json()
      } catch {
        data = {}
      } finally {
        if (!data) data = {}
      }

      if (status < 400) onSuccess(data)
      else onFailure({ status, data })
    })
    .catch(console.error)

export const makeUnauthGetRequest = ({ url, onSuccess, onFailure }) =>
  fetch(urlBeginning + url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "access-control-allow-origin": "*",
    },
  })
    .then(async (el) => {
      const { status } = el

      let data
      try {
        data = await el.json()
      } catch {
        data = {}
      } finally {
        if (!data) data = {}
      }

      if (status < 400) onSuccess(data)
      else onFailure({ status, data })
    })
    .catch(console.error)
